import { useUuidContext } from "hooks/routerHooks";
import { Navigate, Outlet, useParams } from "react-router-dom";

export function ProgressIdGuard() {
  const { progressId } = useParams();
  const { uuid } = useUuidContext();
  const formattedProgressId = +(progressId || "");

  if (!formattedProgressId) return <Navigate to={`/${uuid}/measures`} />;

  return <Outlet context={{ uuid: uuid, progressId: formattedProgressId }} />;
}
